import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BASE_URL } from './utils';

const genericMessage = 'If an eligible account matches that email, a password reset link will be sent.';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [working, setWorking] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setWorking(true);
    setError('');
    try {
      await axios.post(`${BASE_URL}/api/forgot-password`, { email });
      setMessage(genericMessage);
    } catch (requestError) {
      setError(requestError.response?.status >= 500
        ? 'Password recovery is temporarily unavailable. Please try again later.'
        : genericMessage);
    } finally {
      setWorking(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-950">
      <section className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-blue-600">Account recovery</p>
        <h1 className="mt-3 text-3xl font-black text-slate-950 dark:text-white">Reset your password</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">Enter the email used for Pinngro. For privacy, the response is the same whether or not an account matches.</p>
        <form onSubmit={submit} className="mt-6">
          <label className="text-sm font-bold text-slate-800 dark:text-slate-200">
            Email
            <input type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} className="mt-2 block w-full rounded-xl border border-slate-300 bg-transparent px-4 py-3 dark:border-slate-700" />
          </label>
          <button type="submit" disabled={working} className="mt-5 w-full rounded-xl bg-blue-600 px-4 py-3 font-bold text-white hover:bg-blue-700 disabled:opacity-60">
            {working ? 'Requesting link…' : 'Send reset link'}
          </button>
        </form>
        {message && <p className="mt-5 rounded-xl bg-emerald-50 p-4 text-sm text-emerald-900">{message}</p>}
        {error && <p className="mt-5 rounded-xl bg-amber-50 p-4 text-sm text-amber-950">{error}</p>}
        <Link to="/login" className="mt-6 block text-center text-sm font-bold text-blue-700 hover:underline dark:text-blue-300">Back to sign in</Link>
      </section>
    </main>
  );
};

export default ForgotPassword;
